// Discovery Engine — feature gate (pure logic).
//
// Phase 3A controlled product integration. The Discovery workspace is an
// in-development vertical, so it DEFAULTS OFF in production. Enablement precedence
// (mirrors validationEngineFlag.ts — single-tier, fail-OFF):
//   1. local kill (localStorage 'discovery_kill'=1)            → off
//   2. global env override (VITE_DISCOVERY = on|off)
//   3. local opt-in (localStorage 'discovery_optin'=1)         → on
//   4. default                                                 → OFF
//
// When OFF: no Discovery route is reachable, no Discovery sidebar entry is shown,
// and (because the workspace is lazy-loaded behind this gate) the Discovery runtime
// bundle is never fetched. The disabled state is behaviorally identical to the
// product without Discovery.

import { publicEnv } from './clientEnv';

export type DiscoveryGate = { enabled: boolean; reason: string };

export const DISCOVERY_OPTIN_KEY = 'discovery_optin';
export const DISCOVERY_KILL_KEY = 'discovery_kill';

function ls(key: string): string | null {
  try { return typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null; } catch { return null; }
}

export function discoveryGate(): DiscoveryGate {
  const on = (reason: string): DiscoveryGate => ({ enabled: true, reason });
  const off = (reason: string): DiscoveryGate => ({ enabled: false, reason });

  if (ls(DISCOVERY_KILL_KEY) === '1') return off('local_kill');
  const e = (publicEnv('VITE_DISCOVERY') ?? '').toLowerCase();
  if (e === 'on') return on('env_on');
  if (e === 'off') return off('disabled_globally');
  if (ls(DISCOVERY_OPTIN_KEY) === '1') return on('local_optin');
  return off('default_off'); // in-development → off until explicitly enabled
}

// Dev/QA convenience: flip the per-browser opt-in.
export function engageDiscovery(on: boolean): void {
  try {
    if (on) localStorage.setItem(DISCOVERY_OPTIN_KEY, '1');
    else localStorage.removeItem(DISCOVERY_OPTIN_KEY);
  } catch { /* ignore */ }
}
